import { Component } from '@angular/core';

@Component({
  selector: 'app-writers',
  templateUrl: './writers.component.html',
  styleUrls: ['./writers.component.scss']
})
export class WritersComponent {
  // Placeholder component (was referenced in AppModule routes/imports)
}
